/* eslint-disable no-fallthrough */
import { DateTime, type DateTimeFormatOptions } from "luxon";
import { ChartInterval, DatePickerType } from "@/graphql";

export function formatDate(dateTime: DateTime, interval: ChartInterval | DatePickerType, t: any) {
  const dateFormat: DateTimeFormatOptions = {};
  switch (interval) {
    case ChartInterval.SECOND:
    case DatePickerType.SECOND:
      dateFormat.second = "2-digit";
    case ChartInterval.MINUTE:
    case DatePickerType.MINUTE:
      dateFormat.minute = "2-digit";
    case ChartInterval.HOUR:
    case DatePickerType.HOUR:
      dateFormat.hour = "2-digit";
    case ChartInterval.DAY:
    case ChartInterval.SHIFT:
    case DatePickerType.DAY:
      dateFormat.day = "2-digit";
    case ChartInterval.MONTH:
    case DatePickerType.MONTH:
      dateFormat.month = "2-digit";
      dateFormat.year = "2-digit";
      break;
    case ChartInterval.YEAR:
    case ChartInterval.BUSINESS_YEAR:
    case DatePickerType.YEAR:
      dateFormat.year = "numeric";
      break;
    case ChartInterval.WEEK:
    case DatePickerType.WEEK:
      return `${t(
        "license.lisaChart.components.ChartElement.calendarWeekShort",
      )} ${dateTime.weekNumber.toString().padStart(2, "0")}, ${dateTime.year}`;
    default:
      throw Error("unknown interval");
  }
  return dateTime.toLocaleString(dateFormat);
}
